var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube (1) 1",
    clipPath: "url(#clip0_1_4695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.YouTube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.9981 14.5244C30.7324 13.5353 29.9499 12.7529 28.9608 12.4872C27.1746 12 19.9852 12 19.9852 12C19.9852 12 12.7959 12.0148 11.0096 12.5019C10.0205 12.7677 9.23813 13.5501 8.9724 14.5392C8.5 16.3254 8.5 20.0603 8.5 20.0603C8.5 20.0603 8.5 23.7952 8.98716 25.5963C9.25289 26.5854 10.0353 27.3678 11.0244 27.6335C12.8107 28.1207 20 28.1207 20 28.1207C20 28.1207 27.1893 28.1207 28.9756 27.6335C29.9647 27.3678 30.7471 26.5854 31.0128 25.5963C31.5 23.81 31.5 20.0603 31.5 20.0603C31.5 20.0603 31.4852 16.3254 30.9981 14.5244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.6953 23.5153L23.6594 20.0609L17.6953 16.6064V23.5153Z",
    fill: "#FF0000"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.26132bd1aa9981c5acf494e05a377758.svg";
export { ForwardRef as ReactComponent };